export default "__VITE_PUBLIC_ASSET__a6ffd6ac__"